<section class="status-message status-message-global">
    <header class="status-message-header">
        @if (unsubscribe$ | async; as unsubscribe) {
            <priva-header
                [size]="statusMessageHeaderSize"
                [theme]="statusMessageHeaderTheme"
                [title]="
                    ('REPORT_UNSUBSCRIBE_SUCCESS_TITLE' | translate) + ' ' + (unsubscribe?.reportName ?? null)
                "
            >
                <div data-subtitle class="status-message-subtitle">
                    <p>{{ 'REPORT_UNSUBSCRIBE_SUCCESS_SUBTITLE_NO_LONGER' | translate }}</p>
                    <p>
                        {{ 'REPORT_UNSUBSCRIBE_SUBTITLE_VISIT' | translate }}
                        <a href="https://www.priva.com" class="text-link">Priva.com</a>
                    </p>
                </div>
            </priva-header>
        } @else {
            @if (errorObject) {
                <priva-header
                    data-test="unsubscribe-error"
                    [size]="statusMessageHeaderSize"
                    [theme]="statusMessageHeaderTheme"
                    [title]="'REPORT_UNSUBSCRIBE.ERROR.' + errorObject.error + '.TITLE' | translate"
                >
                    <div data-subtitle class="status-message-subtitle">
                        <p>
                            {{ 'REPORT_UNSUBSCRIBE.ERROR.' + errorObject.error + '.MESSAGE' | translate }}
                        </p>
                        <p>
                            {{ 'REPORT_UNSUBSCRIBE_SUBTITLE_VISIT' | translate }}
                            <a href="https://www.priva.com" class="text-link">Priva.com</a>
                        </p>
                    </div>
                </priva-header>
            } @else {
                <div class="loader">
                    <div class="loader__main">
                        <span class="loader__spinner spinner spinner-lg"></span>
                    </div>
                    <div class="loader__footer">
                        {{ 'REPORT_UNSUBSCRIBE.LOADING.TEXT' | translate }}
                    </div>
                </div>
            }
        }
    </header>
</section>
